const select = $('.market-selector .market-selector__select .select.js-set-location');

const changeMarket = (e) => {
  window.location = e.currentTarget.value
}

const events = () => {
  $(select).on('change', changeMarket);
}

const init = () => {
    events();
}

export default init;